import { get, isEmpty, isNil } from 'lodash';
import { resolve } from 'redux-optimist-promise';
import { SIGNOUT } from 'Store/user-info/actions/signout';
import { PROFILE_CHANGED } from 'Store/user-info/actions/notifyProfileChanged';
import {
  SET_ATTENDEES,
  TRIP_INFORMATION_UPDATE_ADULT,
} from 'Store/trip-information/adults/constants';
import { FETCH_PROPOSALS, FETCH_PROPOSALS_BY_ID } from 'Store/booking/proposals/constants';
export const MAIN_CONTACT_INDEX = 0;
type Address = {};
export type State = {
  readonly GMNumber?: string;
  readonly unicodeCivility?: string;
  readonly civility?: string;
  readonly firstName?: string;
  readonly lastName?: string;
  readonly unicodeFirstName?: string;
  readonly unicodeLastName?: string;
  readonly dateOfBirth?: string;
  readonly email?: string;
  readonly homePhoneNumber?: string | null | undefined;
  readonly mobilePhoneNumber?: string | null | undefined;
  readonly isProspect?: boolean;
  readonly isLoggedIn?: boolean;
  readonly optinEmail?: boolean;
  readonly optinSms?: boolean;
  readonly optinMail?: boolean;
  readonly optinFosun?: boolean;
  readonly optinPhone?: boolean;
  readonly optinClubmedPlus?: boolean;
  readonly expirationDate?: number;
  readonly neolaneId?: string;
  readonly updatedDateOfBirth?: string;
  readonly address?: Address;
  readonly locale?: string;
  readonly travelCompanions?: Array<TravelCompanion>;
  readonly loyaltyProgram?: {
    points: number;
    status: string;
  };
};
const initialState: State = {};
export default function userInfoReducer(state: State = initialState, action: Action<any>): State {
  switch (action.type) {
    case SIGNOUT:
      return initialState;

    case PROFILE_CHANGED:
      return { ...state, ...action.payload };

    case SET_ATTENDEES:
    case resolve(FETCH_PROPOSALS):
    case resolve(FETCH_PROPOSALS_BY_ID):
      const { profile } = action.payload;

      // If profile is null, it means that the user is not logged or its token is not valid
      // and existing userInfo and no profile seems weird, but the token being short lived, it can
      // happen
      // address is nullable
      if (profile) {
        return { ...state, ...profile };
      }

      return state;

    case TRIP_INFORMATION_UPDATE_ADULT:
      if (isEmpty(state)) {
        return state;
      }

      const { index, valuesToUpdate } = action.payload;
      const updatedDateOfBirth = get(valuesToUpdate, 'birthdate');
      const optinEmail = get(valuesToUpdate, 'optinEmail');
      const optinSms = get(valuesToUpdate, 'optinSms');
      const optinMail = get(valuesToUpdate, 'optinMail');
      const optinPhone = get(valuesToUpdate, 'optinPhone');
      const optinClubmedPlus = get(valuesToUpdate, 'optinClubmedPlus');

      if (index !== MAIN_CONTACT_INDEX) {
        return state;
      }

      let newState = state;

      if (updatedDateOfBirth) {
        newState = { ...newState, updatedDateOfBirth };
      }

      if (!isNil(optinEmail)) {
        newState = { ...newState, optinEmail };
      }

      if (!isNil(optinSms)) {
        newState = { ...newState, optinSms };
      }

      if (!isNil(optinMail)) {
        newState = { ...newState, optinMail };
      }

      if (!isNil(optinPhone)) {
        newState = { ...newState, optinPhone };
      }

      if (!isNil(optinClubmedPlus)) {
        newState = { ...newState, optinClubmedPlus };
      }

      return newState;

    default:
      return state;
  }
}
